import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { SubpageBanner, SectionHeader } from 'components';

const Banner = () => (
  <StaticQuery
    query={graphql`
      query {
        mainBannerImage: file(
          relativePath: { eq: "pdad/woman-hanging-postits-on-glass-wall.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <SubpageBanner
        backgroundColor={'gray-light'}
        image={data.mainBannerImage.childImageSharp.fluid}
        contentBackground={'red'}
        additionalClass={'pdad__banner'}
        alt={'Planning on the wall'}
      >
        <SectionHeader
          size={'large'}
          color={'black'}
          lineColor={'violet'}
          description={
            'Boldare’s dedicated development teams build custom web and mobile apps with a focus on speed to market. We are able to deliver your digital product MVP in as little as 4-6 weeks employing the lean startup approach and agile software development.'
          }
          hiddenDescription={
            '<br />Our highly-skilled software engineers work in cross-functional teams with designers, QAs and business analysts creating human-centered web products that fulfill user needs and your business goals. Our software development processes and UX and UI standards guarantee the highest product quality in respect of both code quality and design. Moreover, our development teams will consult you along the way and pass on their know-how so you can develop your own in-house processes and team and continue to grow your product independently.'
          }
          descriptionColor={'white'}
          fixed
          additionalClass={'section-header__description--medium'}
        >
          Product Design
          <br />
          and Development
        </SectionHeader>
      </SubpageBanner>
    )}
  />
);

export default Banner;
